import styled from 'styled-components'

export const Main = styled.main`
  background-color: ${props => (props.bgColor ? props.bgColor : 'white')};
  display: flex;
  flex-direction: column;

  /* subtract footer height */
  min-height: calc(100vh - 482px);

  @media screen and (min-width: 600px) {
    min-height: calc(100vh - 282px);
  }

  @media screen and (min-width: 1024px) {
    min-height: calc(100vh - 322px);
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    height: 2000px;
  }

  @supports (-ms-accelerator: true) {
    height: 2000px;
  }
`

export const Wrapper = styled.div`
  position: relative;
  height: ${props => (props.visibleModal ? '100vh' : 'initial')};
  overflow: ${props => (props.visibleModal ? 'hidden' : 'scroll')};
`
